module.exports = "/images/claim_therapist.jpg?0f52b8e80ed2caa21e18973dfefc67cf";